import Axios from "axios";

export const SelectBlFrs = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/FacFrs?typpe=BF&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "BL_FRS_SELECT", payload: response.data });
    });
  };
};
